import { wrapInList, liftListItem } from 'prosemirror-schema-list'
import { Schema, Node, NodeType } from 'prosemirror-model'
import { Transaction, EditorState } from 'prosemirror-state'
import { findParentNode } from '../utils'

export const isList = (node: Node, schema: Schema) => {
  return (
    node.type === schema.nodes.bullet_list ||
    node.type === schema.nodes.ordered_list
  )
}

export const toggleList = (listType: NodeType, itemType: NodeType, listStyleType?: string) => {
  return (state: EditorState, dispatch: (tr: Transaction) => void) => {

    const { schema, selection } = state
    const { $from, $to } = selection
    const range = $from.blockRange($to)
    let fontSize = null;
    let color = '';
    state.doc.nodesBetween($from.pos, $to.pos, (node) => {
      node.marks.forEach((mark) => {
        if (mark.type.name === 'fontsize') {
          fontSize = mark.attrs.fontsize;
        }
        if (mark.type.name === 'forecolor') {
          color = mark.attrs.color;
        }
      });
    });
    if (!range) return false
    const parentList = findParentNode((node: Node) => isList(node, schema))(selection)

    if (range.depth >= 1 && parentList && range.depth - parentList.depth <= 1) {
      if (parentList.node.type === listType && !listStyleType) {
        return liftListItem(itemType)(state, dispatch)
      }

      if (isList(parentList.node, schema) && listType.validContent(parentList.node.content)) {

        const { tr } = state
        if (listStyleType) {
          const nodeAttrs = {
            ...parentList.node.attrs,
            listStyleType: listStyleType,
            fontSize: fontSize || parentList.node.attrs.fontSize,
            color: color,
            marginLeft: fontSize ? `${parseInt(fontSize) + 10}px` : null,
          }
          tr.setNodeMarkup(parentList.pos, listType, nodeAttrs)
        }
        else tr.setNodeMarkup(parentList.pos, listType)

        if (dispatch) dispatch(tr)
        console.log("After dispatch:", state.doc.toJSON());

        return false
      }
    }


      const { tr } = state
      const attrs = {
        listStyleType: listStyleType,
        fontSize: fontSize,
        color: color,
        marginLeft: fontSize ? `${parseInt(fontSize) + 10}px` : null,
      }
      if (!listStyleType) return wrapInList(listType, attrs)(state, dispatch)
      dispatch(tr);

      return wrapInList(listType, attrs)(state, dispatch)
  }
}